'use client';

import type { SelectToken } from '@/types';
import { useUserBalance } from '@/hooks/useUserBalance';
import { displayAmount } from '@/utils/token';

interface TokenAmountProps {
  token: SelectToken;
}

export function TokenAmount({ token }: TokenAmountProps) {
  const balance = useUserBalance(token);
  return displayAmount(balance.totalFormatted);
}
